export default __webpack_public_path__ + "95407d1e5172b983b871ff66a21755fd.svg";